import MockAdapter from 'axios-mock-adapter'
import { http } from '../api/v1/http'

export const mocker = new MockAdapter(http, {
  onNoMatch: 'passthrough',
})

export type Mock = (
  factory: (mocker: MockAdapter) => void,
  enableFactory?: 0 | 1,
) => void

export function mock(
  factory: (mocker: MockAdapter) => void,
  enableFactory: 0 | 1 = 0,
) {
  if (!!enableFactory) factory(mocker)
}
